import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PageContainer from "../components/common/PageContainer";
import ChecklistForm from "../components/checklist/ChecklistForm";

/**
 * Page component for creating a new checklist
 */
const ChecklistCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const templateId = queryParams.get("templateId");

  // In a real application, we would fetch the template data if templateId is provided
  const templateData = templateId
    ? {
        title: "Template Title", // This would come from the API
        description: "Template Description", // This would come from the API
        items: [
          { id: "item-1", text: "Template Item 1", completed: false },
          { id: "item-2", text: "Template Item 2", completed: false },
        ],
      }
    : null;

  const handleSave = (checklistData) => {
    // In a real application, we would save the checklist to the API
    console.log("Saving checklist:", checklistData);

    // For now, we'll just navigate back to the checklists page
    navigate("/checklists");
  };

  const handleCancel = () => {
    navigate("/checklists");
  };

  return (
    <PageContainer
      title="Create New Checklist"
      breadcrumbs={[
        { text: "Checklists", path: "/checklists" },
        { text: "Create New Checklist" },
      ]}
    >
      <ChecklistForm
        checklist={templateData}
        onSave={handleSave}
        onCancel={handleCancel}
      />
    </PageContainer>
  );
};

export default ChecklistCreate;
